/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentContentRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/content';

export default class AutomationFinAIAgentSalesContentRoute extends AutomationFinAIAgentContentRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.sales.content',
  };
}
